<template>
  <div class="anchor-info">
    <div class="anchor-header">
      <div class="header">
        <div class="header-left" @click="back">
          <img src="./img/back-arrow.png" alt="" />
          <div>主播信息</div>
        </div>
        <div class="header-right">
          <div class="btn" @click="toPrivateChat">
            <img src="./img/chat.png" alt="" />
            <div>与主播私聊</div>
          </div>
          <div class="btn btn1" @click="onFollow()" v-show="!isFollowed">
            <img src="./img/add.png" alt="" />
            <div>关注</div>
          </div>
          <div class="btn btn2" @click="onFollow()" v-show="isFollowed">
            <img src="./img/check.png" alt="" />
            <div>已关注</div>
          </div>
        </div>
      </div>
      <img :src="anchorInfo.avatar" alt="" class="anchor-avatar" />
      <div class="anchor-name">
        <div>{{ anchorInfo.name }}</div>
        <img :src="levelToPicture(anchorInfo.user_level)" alt="" />
      </div>
      <div class="anchor-id">直播ID：{{ anchorInfo.id }}</div>
      <div class="anchor-data">
        <div class="cluster">
          <div class="up">最高人气</div>
          <div class="down">{{ $bigNumber(anchorInfo.high_hot) }}</div>
        </div>
        <div class="bar"></div>
        <div class="cluster">
          <div class="up">粉丝数量</div>
          <div class="down">{{ $bigNumber(anchorInfo.fans_count) }}</div>
        </div>
        <div class="bar"></div>
        <div class="cluster">
          <div class="up">直播类型</div>
          <div class="down">{{ anchorInfo.category_name }}</div>
        </div>
      </div>
      <div class="anchor-desc">
        <div class="title">主播简介</div>
        <div class="desc text-overflow-twoline" v-show="anchorInfo.introduce">{{ anchorInfo.introduce }}</div>
        <div class="desc text-overflow-twoline" v-show="!anchorInfo.introduce">暂无简介</div>
      </div>
    </div>
    <img src="./img/group-icon.png" alt="" class="group-title" />
    <div class="fans-group">
      <div class="fans-list" @click="toGroupInfo(item)" v-for="(item, index) in fansGroups" :key="index">
        <div class="fans-content">
          <div class="fans-title text-overflow">{{ item.name }}</div>
          <div class="fans-members">
            <img v-show="item.user_num !== item.limit_num" src="./img/group.png" alt="" />
            <img v-show="item.user_num === item.limit_num" src="./img/group-full.png" alt="" />
            <div :style="{ color: item.user_num === item.limit_num ? '#DB6372' : '' }">{{ item.user_num }}/{{ item.limit_num }}</div>
          </div>
        </div>
        <div class="btn" @click.stop="joinGroup(item)" v-show="!item.is_joined && item.user_num !== item.limit_num">加入</div>
        <div class="btn" @click.stop="toGroupChat(item)" style="background: #02a8a2" v-show="item.is_joined && item.user_num !== item.limit_num">进入群聊</div>
        <div class="btn" @click.stop="toGroupChat(item)" style="background: #db6372" v-show="item.user_num === item.limit_num">该群已满员</div>
      </div>
      <div class="empty" v-show="fansGroups.length === 0">
        <img src="@/assets/img/empty/no-data.png" alt="" />
        <div>暂无群聊</div>
      </div>
    </div>
  </div>
</template>

<script>
import { levelToPicture } from "@/util/picNumber";
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
import { format } from "@/util/time";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig", "privateMessageList", "fansGroups", "anchorInfo", "isFollowed"]),
    roomId() {
      return this.liveDetail.anchorid || 0;
    },
  },
  props: {
    liveDetail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {},
  data() {
    return {
      messageContent: "",
    };
  },
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLogin", "pushToast", "changePrivateMessageList", "changeIsFollowed"]),
    ...mapActions(["onFollow"]),
    levelToPicture,
    back() {
      this.$emit("changeAnchorInfo", false);
    },
    toGroupChat(item) {
      this.$emit("toGroupChat", item);
    },
    toGroupInfo(item) {
      this.$emit("toGroupInfo", item);
    },
    joinGroup(item) {
      this.$emit("joinGroup", item);
    },
    toPrivateChat() {
      this.$emit("toPrivateChat");
    },
    // onFollow(val) {
    //   if (!this.userInfo.id) {
    //     this.toggleLogin();
    //     return;
    //   }
    //   if (this.userInfo.id == this.roomId) {
    //     this.pushToast("不能关注自己");
    //     return;
    //   }
    //   post({
    //     url: "/api/anchor/attentAnchor",
    //     data: {
    //       anchorid: this.roomId,
    //       // device: str
    //     },
    //   }).then(({ data: { data } }) => {
    //     this.changeIsFollowed(data.type);
    //     let text = data.type == 1 ? "关注成功" : "取消关注";
    //     this.pushToast(text);
    //   });
    // },
  },
};
</script>

<style scoped lang="scss">
.anchor-info {
  margin-top: 0.12rem;
  margin-right: 0.4rem;
  width: 3.4rem;
  display: flex;
  flex-direction: column;
  background: #f9f9fb;
}
.anchor-header {
  height: 4rem;
  background: url("./img/anchor-info-bg.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .header {
    margin-top: 0.12rem;
    height: 0.27rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .header-left {
      display: flex;
      cursor: pointer;
      img {
        width: 0.16rem;
        margin-left: 0.12rem;
        margin-right: 0.04rem;
      }
    }
    .header-right {
      display: flex;
      margin-right: 0.12rem;
      .btn {
        width: 1.02rem;
        height: 0.27rem;
        background: linear-gradient(116.07deg, #ffd600 17.03%, #ff8f00 84.18%);
        border-radius: 0.27rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 0.12rem;
        margin-right: 0.08rem;
        cursor: pointer;
        img {
          width: 0.16rem;
          margin-right: 0.03rem;
        }
      }
      .btn1 {
        width: 0.64rem;
        background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
        img {
          width: 0.12rem;
        }
      }
      .btn2 {
        width: 0.64rem;
        background: #dbdbdb;
        color: #666666;
        img {
          width: 0.12rem;
        }
      }
    }
  }
  .anchor-avatar {
    margin-top: 0.32rem;
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 0.9rem;
  }
  .anchor-name {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.18rem;
    font-weight: 600;
    margin-top: 0.05rem;
    img {
      height: 0.18rem;
      margin-left: 0.06rem;
    }
  }
  .anchor-id {
    margin-top: 0.06rem;
    color: #666666;
  }
  .anchor-data {
    display: flex;
    align-items: center;
    margin-top: 0.3rem;
    .cluster {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: 700;
      font-size: 0.2rem;
      .up {
        margin-bottom: 0.06rem;
        font-size: 0.12rem;
        color: #999999;
      }
    }
    .bar {
      margin: 0 0.27rem;
      width: 1px;
      height: 0.32rem;
      background: linear-gradient(180deg, rgba(153, 153, 153, 0) 0%, #999999 52.08%, rgba(153, 153, 153, 0) 100%);
      opacity: 0.5;
    }
  }
  .anchor-desc {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 0.86rem;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(2px);
    border-radius: 20px 20px 0px 0px;
    padding: 0.14rem 0.2rem;
    .title {
      font-weight: 500;
    }
    .desc {
      font-size: 0.12rem;
      margin-top: 0.06rem;
      color: #666666;
      line-height: 0.17rem;
    }
  }
}
.group-title {
  height: 0.26rem;
  margin: 0.25rem auto;
}
.fans-group {
  padding: 0 0.12rem;
  overflow: scroll;
  flex: 1;
  .empty {
    font-size: 0.12rem;
    color: #999999;
    text-align: center;
    margin-top: 0.5rem;
    img {
      width: 1.4rem;
      margin-bottom: 0.24rem;
    }
  }
  .fans-list {
    height: 0.62rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border-radius: 0.1rem;
    padding: 0 0.16rem;
    margin-bottom: 0.08rem;
    cursor: pointer;
    .fans-title {
      width: 1.57rem;
    }
    .fans-members {
      width: 0.68rem;
      height: 0.2rem;
      background: #eeeeee;
      border-radius: 0.02rem;
      color: #666666;
      font-size: 0.12rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.04rem;
      img {
        width: 0.1rem;
        margin-right: 0.02rem;
      }
    }
    .btn {
      width: 0.88rem;
      height: 0.3rem;
      background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
      border-radius: 0.3rem;
      color: #ffffff;
      line-height: 0.3rem;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
